import RestResource from '../rest.service';
import Service from '../api.service';

export default class DeliveryNotesService extends RestResource {
  map(payload) {
    return {
      code: payload.code,
      date: payload.date,
      compliance: payload.compliance,
      delivery_note_type_id: payload.type,
      user_id: payload.user.id,
      producer_id: payload.producer ? payload.producer.id : null,
      campaign_id: payload.campaign.id,
      distributor_from: payload.distributorFrom ? payload.distributorFrom.id : null,
      distributor_to: payload.distributorTo ? payload.distributorTo.id : null,
    };
  }

  confirm(id) {
    return Service.post(`${this.getResource({ id })}/confirm`).catch(this.handleErrors);
  }

  findByCode(code) {
    return Service.get(`${this.getResource()}/find-by-code/${code}`).catch(this.handleErrors);
  }

  constructor() {
    super('delivery-notes');
  }
}
